import React from 'react';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface TrainingSampleHeaderProps {
  title: string;
  totalCount?: number;
  onAddNew?: () => void;
  showAddButton?: boolean;
}

export const TrainingSampleHeader: React.FC<TrainingSampleHeaderProps> = ({
  title,
  totalCount,
  onAddNew,
  showAddButton = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'space-between', 
      alignItems: { xs: 'flex-start', sm: 'center' },
      gap: { xs: 2, sm: 0 },
      mb: 3 
    }}>
      <Box>
        <Typography 
          variant={isMobile ? "h5" : "h4"} 
          component="h1"
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 0.5,
          }}
        >
          {title}
        </Typography>
        {totalCount !== undefined && (
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ 
              fontWeight: 500,
            }}
          >
            {totalCount.toLocaleString()} samples total
          </Typography>
        )}
      </Box>
      
      {showAddButton && onAddNew && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddNew}
          size={isMobile ? "medium" : "large"}
          sx={{
            borderRadius: 2,
            px: { xs: 2, sm: 3 },
            py: { xs: 1, sm: 1.5 },
            fontSize: { xs: '0.875rem', sm: '1rem' },
            fontWeight: 600,
            alignSelf: { xs: 'stretch', sm: 'auto' },
          }}
        >
          Add Sample
        </Button>
      )}
    </Box>
  );
};